import { render } from "./CBarChart.vue?vue&type=template&id=afbe0498"
import script from "./CBarChart.vue?vue&type=script&lang=js"
export * from "./CBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__